<template>
  <g fill="none" stroke="#333333">
    <circle cx="9" cy="9" r="3" />
    <circle cx="9" cy="9" r="7" />
  </g>
</template>
